/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ApiError,
  CreateOAuthClientBody,
  OAuthClient,
  OAuthCode,
  OAuthRefreshTokenBody,
  OAuthToken,
  UpdateOAuthClientBody,
} from '../models/index';
import {
    ApiErrorFromJSON,
    ApiErrorToJSON,
    CreateOAuthClientBodyFromJSON,
    CreateOAuthClientBodyToJSON,
    OAuthClientFromJSON,
    OAuthClientToJSON,
    OAuthCodeFromJSON,
    OAuthCodeToJSON,
    OAuthRefreshTokenBodyFromJSON,
    OAuthRefreshTokenBodyToJSON,
    OAuthTokenFromJSON,
    OAuthTokenToJSON,
    UpdateOAuthClientBodyFromJSON,
    UpdateOAuthClientBodyToJSON,
} from '../models/index';

export interface CreateOauthClientRequest {
    createOAuthClientBody?: CreateOAuthClientBody;
}

export interface CreateOauthTokenRequest {
    oAuthRefreshTokenBody: OAuthRefreshTokenBody;
}

export interface DeleteOauthClientIdRequest {
    id: string;
}

export interface GetOauthAuthorizeRequest {
    responseType: string;
    clientId: string;
    redirectUri: string;
    scope: string;
    state?: string;
}

export interface GetOauthClientsIdRequest {
    id: string;
}

export interface GetOauthInitRequest {
    clientId?: string;
    responseType?: string;
    redirectUri?: string;
}

export interface UpdateOauthClientIdRequest {
    id: string;
    updateOAuthClientBody?: UpdateOAuthClientBody;
}

/**
 * OAuth2Api - interface
 * 
 * @export
 * @interface OAuth2ApiInterface
 */
export interface OAuth2ApiInterface {
    /**
     * Used by admins to create new OAuth client application.
     * @param {CreateOAuthClientBody} [createOAuthClientBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OAuth2ApiInterface
     */
    createOauthClientRaw(requestParameters: CreateOauthClientRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OAuthClient>>;

    /**
     * Used by admins to create new OAuth client application.
     */
    createOauthClient(requestParameters: CreateOauthClientRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OAuthClient>;

    /**
     * Generate a new token to allow third parties to access our platform.
     * @param {OAuthRefreshTokenBody} oAuthRefreshTokenBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OAuth2ApiInterface
     */
    createOauthTokenRaw(requestParameters: CreateOauthTokenRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OAuthToken>>;

    /**
     * Generate a new token to allow third parties to access our platform.
     */
    createOauthToken(requestParameters: CreateOauthTokenRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OAuthToken>;

    /**
     * Used by admins to delete an OAuth client. Blocked while a partner service or placement still references it.
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OAuth2ApiInterface
     */
    deleteOauthClientIdRaw(requestParameters: DeleteOauthClientIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Used by admins to delete an OAuth client. Blocked while a partner service or placement still references it.
     */
    deleteOauthClientId(requestParameters: DeleteOauthClientIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * Generate a new authorization code for OAuth2 access & refresh tokens.
     * @param {string} responseType response_type is set to code indicating that you want an authorization code as the response.
     * @param {string} clientId The client_id is the identifier for your app. You will have received a client_id when first registering your app with the service.
     * @param {string} redirectUri The redirect_uri may be optional depending on the API, but is highly recommended. This is the URL to which you want the user to be redirected after the authorization is complete. This must match the redirect URL that you have previously registered with the service.
     * @param {string} scope Include one or more scope values (space-separated) to request additional levels of access. The values will depend on the particular service.
     * @param {string} [state] When the user is redirected back to your app, whatever value you include as the state will also be included in the redirect.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OAuth2ApiInterface
     */
    getOauthAuthorizeRaw(requestParameters: GetOauthAuthorizeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OAuthCode>>;

    /**
     * Generate a new authorization code for OAuth2 access & refresh tokens.
     */
    getOauthAuthorize(requestParameters: GetOauthAuthorizeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OAuthCode>;

    /**
     * Get OAuth client data.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OAuth2ApiInterface
     */
    getOauthClientsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<OAuthClient>>>;

    /**
     * Get OAuth client data.
     */
    getOauthClients(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<OAuthClient>>;

    /**
     * Get OAuth client data.
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OAuth2ApiInterface
     */
    getOauthClientsIdRaw(requestParameters: GetOauthClientsIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OAuthClient>>;

    /**
     * Get OAuth client data.
     */
    getOauthClientsId(requestParameters: GetOauthClientsIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OAuthClient>;

    /**
     * This is where the app will redirect the user to initialize the oAuth process.
     * @param {string} [clientId] 
     * @param {string} [responseType] 
     * @param {string} [redirectUri] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OAuth2ApiInterface
     */
    getOauthInitRaw(requestParameters: GetOauthInitRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * This is where the app will redirect the user to initialize the oAuth process.
     */
    getOauthInit(requestParameters: GetOauthInitRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * Used by admins to update an OAuth client\'s name, logo, redirect URIs, or scopes.
     * @param {string} id 
     * @param {UpdateOAuthClientBody} [updateOAuthClientBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OAuth2ApiInterface
     */
    updateOauthClientIdRaw(requestParameters: UpdateOauthClientIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OAuthClient>>;

    /**
     * Used by admins to update an OAuth client\'s name, logo, redirect URIs, or scopes.
     */
    updateOauthClientId(requestParameters: UpdateOauthClientIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OAuthClient>;

}

/**
 * 
 */
export class OAuth2Api extends runtime.BaseAPI implements OAuth2ApiInterface {

    /**
     * Used by admins to create new OAuth client application.
     */
    async createOauthClientRaw(requestParameters: CreateOauthClientRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OAuthClient>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Admin", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/oauth/client`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateOAuthClientBodyToJSON(requestParameters['createOAuthClientBody']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OAuthClientFromJSON(jsonValue));
    }

    /**
     * Used by admins to create new OAuth client application.
     */
    async createOauthClient(requestParameters: CreateOauthClientRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OAuthClient> {
        const response = await this.createOauthClientRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Generate a new token to allow third parties to access our platform.
     */
    async createOauthTokenRaw(requestParameters: CreateOauthTokenRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OAuthToken>> {
        if (requestParameters['oAuthRefreshTokenBody'] == null) {
            throw new runtime.RequiredError(
                'oAuthRefreshTokenBody',
                'Required parameter "oAuthRefreshTokenBody" was null or undefined when calling createOauthToken().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/oauth/token`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: OAuthRefreshTokenBodyToJSON(requestParameters['oAuthRefreshTokenBody']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OAuthTokenFromJSON(jsonValue));
    }

    /**
     * Generate a new token to allow third parties to access our platform.
     */
    async createOauthToken(requestParameters: CreateOauthTokenRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OAuthToken> {
        const response = await this.createOauthTokenRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Used by admins to delete an OAuth client. Blocked while a partner service or placement still references it.
     */
    async deleteOauthClientIdRaw(requestParameters: DeleteOauthClientIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling deleteOauthClientId().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Admin", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/oauth/client/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Used by admins to delete an OAuth client. Blocked while a partner service or placement still references it.
     */
    async deleteOauthClientId(requestParameters: DeleteOauthClientIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteOauthClientIdRaw(requestParameters, initOverrides);
    }

    /**
     * Generate a new authorization code for OAuth2 access & refresh tokens.
     */
    async getOauthAuthorizeRaw(requestParameters: GetOauthAuthorizeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OAuthCode>> {
        if (requestParameters['responseType'] == null) {
            throw new runtime.RequiredError(
                'responseType',
                'Required parameter "responseType" was null or undefined when calling getOauthAuthorize().'
            );
        }

        if (requestParameters['clientId'] == null) {
            throw new runtime.RequiredError(
                'clientId',
                'Required parameter "clientId" was null or undefined when calling getOauthAuthorize().'
            );
        }

        if (requestParameters['redirectUri'] == null) {
            throw new runtime.RequiredError(
                'redirectUri',
                'Required parameter "redirectUri" was null or undefined when calling getOauthAuthorize().'
            );
        }

        if (requestParameters['scope'] == null) {
            throw new runtime.RequiredError(
                'scope',
                'Required parameter "scope" was null or undefined when calling getOauthAuthorize().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['responseType'] != null) {
            queryParameters['response_type'] = requestParameters['responseType'];
        }

        if (requestParameters['clientId'] != null) {
            queryParameters['client_id'] = requestParameters['clientId'];
        }

        if (requestParameters['redirectUri'] != null) {
            queryParameters['redirect_uri'] = requestParameters['redirectUri'];
        }

        if (requestParameters['state'] != null) {
            queryParameters['state'] = requestParameters['state'];
        }

        if (requestParameters['scope'] != null) {
            queryParameters['scope'] = requestParameters['scope'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("User", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/oauth/authorize`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OAuthCodeFromJSON(jsonValue));
    }

    /**
     * Generate a new authorization code for OAuth2 access & refresh tokens.
     */
    async getOauthAuthorize(requestParameters: GetOauthAuthorizeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OAuthCode> {
        const response = await this.getOauthAuthorizeRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get OAuth client data.
     */
    async getOauthClientsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<OAuthClient>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Admin", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/oauth/clients`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(OAuthClientFromJSON));
    }

    /**
     * Get OAuth client data.
     */
    async getOauthClients(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<OAuthClient>> {
        const response = await this.getOauthClientsRaw(initOverrides);
        return await response.value();
    }

    /**
     * Get OAuth client data.
     */
    async getOauthClientsIdRaw(requestParameters: GetOauthClientsIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OAuthClient>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getOauthClientsId().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/oauth/clients/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OAuthClientFromJSON(jsonValue));
    }

    /**
     * Get OAuth client data.
     */
    async getOauthClientsId(requestParameters: GetOauthClientsIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OAuthClient> {
        const response = await this.getOauthClientsIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * This is where the app will redirect the user to initialize the oAuth process.
     */
    async getOauthInitRaw(requestParameters: GetOauthInitRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        if (requestParameters['clientId'] != null) {
            queryParameters['client_id'] = requestParameters['clientId'];
        }

        if (requestParameters['responseType'] != null) {
            queryParameters['response_type'] = requestParameters['responseType'];
        }

        if (requestParameters['redirectUri'] != null) {
            queryParameters['redirect_uri'] = requestParameters['redirectUri'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/oauth/init`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * This is where the app will redirect the user to initialize the oAuth process.
     */
    async getOauthInit(requestParameters: GetOauthInitRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.getOauthInitRaw(requestParameters, initOverrides);
    }

    /**
     * Used by admins to update an OAuth client\'s name, logo, redirect URIs, or scopes.
     */
    async updateOauthClientIdRaw(requestParameters: UpdateOauthClientIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OAuthClient>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling updateOauthClientId().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Admin", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/oauth/client/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateOAuthClientBodyToJSON(requestParameters['updateOAuthClientBody']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OAuthClientFromJSON(jsonValue));
    }

    /**
     * Used by admins to update an OAuth client\'s name, logo, redirect URIs, or scopes.
     */
    async updateOauthClientId(requestParameters: UpdateOauthClientIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OAuthClient> {
        const response = await this.updateOauthClientIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
